<template>
  <div
    class="flex items-center justify-center min-h-screen px-4"
    :class="[userStore.isLoggedIn ? '-ml-60' : '']"
  >
    <div
      class="max-w-[500px] w-full shadow-card rounded-xl"
      :class="mode === 'dark' ? 'bg-dark-70' : 'bg-white-100'"
    >
      <nav
        class="border-b flex space-x-4 px-1"
        :class="mode === 'dark' ? 'border-dark-50' : ''"
      >
        <div
          class="inline-flex items-center relative p-4 text-[15px] nav-tab"
          :class="
            activeTab === 'sign-up'
              ? 'active font-medium'
              : mode === 'dark'
              ? 'text-dark-15'
              : 'text-gray-500'
          "
        >
          Step 1 - Sign up
        </div>
        <div
          class="inline-flex items-center relative p-4 text-[15px] nav-tab"
          :class="
            activeTab === 'subscribe-plan'
              ? 'active font-medium'
              : mode === 'dark'
              ? 'text-dark-15'
              : 'text-gray-500'
          "
        >
          Step 2 - Pick a plan & subscribe
        </div>
      </nav>
      <div v-if="activeTab === 'sign-up'" class="p-6">
        <div class="mb-5 text-center">
          <p class="text-lg font-medium">
            You're just one <span class="font-bold">quick step</span> from
            unlocking
            <span class="fw-bold"
              >$5000 WORTH of SEO Optimization. Securely log in</span
            >
            or Create a new account now!
          </p>
        </div>
        <div class="grid gap-6 mb-5">
          <div class="flex flex-col gap-2 items-center">
            <SignInWithGoogleButton
              :mode="mode"
              @on-signup="onOnSignupWithGoogle"
              label="Sign up with Google"
            />
            <div class="text-center">
              <RouterLink
                :to="{
                  name: 'signin',
                }"
                class="text-[15px] hover:text-primary-100"
                >Use Existing Account Details</RouterLink
              >
            </div>
          </div>
          <div
            class="border-b relative flex items-center justify-center"
            :class="mode === 'dark' ? 'border-dark-50' : ''"
          >
            <span
              class="absolute w-10 h-10 rounded-full flex items-center justify-center z-10"
              :class="mode === 'dark' ? 'bg-dark-70' : 'bg-white-100'"
              >OR</span
            >
          </div>
        </div>
        <div class="grid gap-4">
          <div class="relative">
            <label for="current-email" class="text-[15px] mb-1 block"
              >Email address</label
            >
            <input
              type="text"
              class="form-field pl-9"
              placeholder="Make new account"
              v-model="email"
            />
            <div
              class="absolute bottom-0 left-2.5 flex h-11 items-center text-gray-0 text-opacity-70"
            >
              <AtSign :size="20" :stroke-width="1.75" />
            </div>
          </div>
          <div class="relative">
            <label for="old-pass" class="text-[15px] mb-1 block"
              >Password</label
            >
            <input
              :type="[isPassword ? 'text' : 'password']"
              class="form-field pl-9"
              placeholder="Enter password"
              v-model="password1"
            />
            <div
              class="absolute bottom-0 left-2.5 flex h-11 items-center text-gray-0 text-opacity-70"
            >
              <LockKeyhole :size="20" :stroke-width="1.75" />
            </div>
            <div
              class="absolute bottom-0 right-4 flex h-11 items-center cursor-pointer"
            >
              <span
                @click="isPassword = !isPassword"
                class="text-primary-100 text-sm hover:underline hover:decoration-dashed"
                >{{ isPassword ? "Hide" : "Show" }}</span
              >
            </div>
          </div>
          <div class="relative">
            <label for="confirm-new-pass" class="text-[15px] mb-1 block"
              >Confirm password</label
            >
            <input
              :type="[isPasswordConfirm ? 'text' : 'password']"
              class="form-field pl-9"
              placeholder="Confirm password"
              v-model="password2"
            />
            <div
              class="absolute bottom-0 left-2.5 flex h-11 items-center text-gray-0 text-opacity-70"
            >
              <LockKeyhole :size="20" :stroke-width="1.75" />
            </div>
            <div
              @click="isPasswordConfirm = !isPasswordConfirm"
              class="absolute bottom-0 right-4 flex h-11 items-center cursor-pointer"
            >
              <span
                class="text-primary-100 text-sm hover:underline hover:decoration-dashed"
                >{{ isPasswordConfirm ? "Hide" : "Show" }}</span
              >
            </div>
          </div>
        </div>
        <div class="mt-5">
          <div class="flex items-center flex-col gap-4">
            <div class="flex items-center gap-4">
              <img
                class="h-12"
                src="../assets/img/secure_checkou_logot.png"
                alt="logo"
              />
              <img
                class="h-12"
                src="../assets/img/paypal_logo.png"
                alt="logo"
              /><img
                class="h-12"
                src="../assets/img/stripe_logo.png"
                alt="logo"
              />
            </div>
            <button class="button primary-button w-full" @click="signUp">
              Sign up and continue to next step
            </button>
          </div>
        </div>
      </div>
      <div v-if="activeTab === 'subscribe-plan'" class="p-6">
        <div class="mb-5 text-center">
          <p class="text-lg font-medium">
            Now simple
            <span class="font-bold">Choose the plan</span> right for you. Build
            <span class="font-bold">more and better pages, for</span>
            for
            <span class="font-bold"> less money and in less time!</span>
          </p>
        </div>
        <div class="grid gap-4">
          <div>
            <label for="plans" class="text-[15px] mb-1 block"
              >Select plan</label
            >
            <Multiselect
              id="plans"
              class="form-field"
              :object="true"
              v-model="selectedPlan"
              :options="plans"
              placeholder="Choose plan"
              :searchable="true"
              :canDeselect="true"
            ></Multiselect>
          </div>
          <div>
            <label for="coupon" class="text-[15px] mb-1 block"
              >Enter code</label
            >
            <input
              id="coupon"
              placeholder="Enter coupon code"
              v-model="coupon"
              class="form-field"
            />
          </div>
        </div>
        <div
          class="mt-5"
          v-if="selectedPlan && Object.keys(selectedPlan).length !== 0"
        >
          <div
            class="p-3 text-center rounded-lg border"
            :class="mode === 'dark' ? 'bg-dark-70 border-dark-50' : 'bg-gray-1'"
          >
            <p class="text-[15px]">
              {{
                `${selectedPlan.name}.....Approx ${selectedPlan.benefits[1]}.....Only ${selectedPlan.pricing}`
              }}
            </p>
          </div>
        </div>
        <div class="mt-5" v-if="!subscribeStatus">
          <div class="flex items-center flex-col gap-4">
            <div class="flex items-center gap-4">
              <img
                class="h-12"
                src="../assets/img/secure_checkou_logot.png"
                alt="logo"
              />
              <img
                class="h-12"
                src="../assets/img/paypal_logo.png"
                alt="logo"
              /><img
                class="h-12"
                src="../assets/img/stripe_logo.png"
                alt="logo"
              />
            </div>
            <button
              class="button primary-button w-full"
              :disabled="
                !selectedPlan ||
                (selectedPlan && Object.keys(selectedPlan).length === 0)
              "
              @click="onSubscribeNow"
            >
              Subscribe Now
            </button>
          </div>
        </div>
        <div class="mt-5 grid gap-4" v-if="subscribeStatus">
          <div class="flex items-center">
            <button
              class="button primary-button flex-1"
              :disabled="
                !selectedPlan ||
                (selectedPlan && Object.keys(selectedPlan).length === 0)
              "
              @click="subscribeWithPayPalPlan"
            >
              Subscribe Now (PayPal)
            </button>
          </div>
          <div class="flex items-center">
            <button
              class="button primary-button flex-1"
              :disabled="
                !selectedPlan ||
                (selectedPlan && Object.keys(selectedPlan).length === 0)
              "
              @click="subscribePlanWithStripe"
            >
              Subscribe Now (Stripe)
            </button>
          </div>
        </div>
        <div v-show="paypalSubscribePlan === selectedPlan" class="mt-4">
          <div :id="`paypal-btn-${selectedPlan && selectedPlan.price_id}`">
            &nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadScript } from "@paypal/paypal-js";
import helper from "../libs/helper";
import { useUserStore } from "../stores/user";
import ApiRequest from "../libs/ApiRequest";
import SignInWithGoogleButton from "../components/common/SignInWithGoogleButton.vue";
import Multiselect from "@vueform/multiselect";
import { AtSign, LockKeyhole } from "lucide-vue-next";
export default {
  setup() {
    return {
      userStore: useUserStore(),
    };
  },
  props: {
    mode: String,
  },
  components: {
    SignInWithGoogleButton,
    Multiselect,
    AtSign,
    LockKeyhole,
  },
  data() {
    return {
      email: "",
      password1: "",
      password2: "",
      coupon: "",
      selectedPlan: {},
      plans: [],
      accessToken: "",
      paypalSubscribePlan: null,
      renderedPayPalButtonsForPlan: [],
      paypalSDK: null,
      activeTab: "sign-up",
      subscribeStatus: false,
      isPassword: false,
      isPasswordConfirm: false,
    };
  },
  async mounted() {
    this.userStore.setIsLoading(!0);
    this.accessToken = localStorage.getItem("access_token");
    if (this.accessToken) {
      await this.loadPlans();
      this.activeTab = "subscribe-plan";
    }
    this.userStore.setIsLoading(!1);
  },
  methods: {
    onSubscribeNow() {
      this.subscribeStatus = true;
    },
    async onOnSignupWithGoogle(route, data) {
      this.accessToken = data.access;
      await this.loadPlans();
      this.activeTab = "subscribe-plan";
    },
    async signUp() {
      try {
        this.userStore.setIsLoading(!0);
        if (!this.email) {
          throw new Error("Email can't be empty");
        }
        if (!this.password1) {
          throw new Error("Password can't be empty");
        }
        if (this.password1 !== this.password2) {
          throw new Error("Password & Confirm Password must match!");
        }
        const postData = {
          first_name: "",
          last_name: "",
          password: this.password1,
          password2: this.password2,
        };
        let response;
        if (this.$route.name === "team-signup") {
          const inviteUUID = this.$route.params.uuid;
          if (!inviteUUID) {
            throw new Error("Invalid invite code!");
          }
          response = await ApiRequest().put(
            `/api/auth/team/signup/${inviteUUID}`,
            postData
          );
        } else {
          if (!this.email) {
            throw new Error("Email can't be empty");
          }
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailPattern.test(this.email)) {
            throw new Error("Email is invalid");
          }
          postData.email = this.email;
          response = await ApiRequest("skip").post(
            `/api/auth/signup`,
            postData
          );
        }
        if (response.status === 201 || response.status === 200) {
          const postData = {
            email: this.email,
            password: this.password1,
          };
          const URL = `/api/auth/token/obtain`;
          const { data } = await ApiRequest().post(URL, postData);
          if (data && data.access) {
            this.accessToken = data.access;
            await this.loadPlans();
          }
          this.activeTab = "subscribe-plan";
          this.$toast.success("Account created successfully");
        }
        this.userStore.setIsLoading(!1);
      } catch (error) {
        this.userStore.setIsLoading(!1);
        const extractedError = helper.extractAlert(error, "signup");
        this.$toast.error(extractedError.alert.message);
      }
    },
    async loadPlans() {
      try {
        const { data } = await ApiRequest().get(`/api/payments/tier-list`, {
          headers: {
            Authorization: `Bearer ${this.accessToken}`,
          },
        });
        if (data) {
          const plans = data.map((plan) => {
            return {
              ...plan,
              label: `${plan.name} ( ${plan.benefits[1]} ) ${plan.pricing}`,
              value: plan.price_id,
            };
          });
          this.plans = plans;
        }
      } catch (error) {
        const extractedError = helper.extractAlert(error, "plans");
        this.$toast.error(extractedError.alert.message);
      }
    },
    async subscribePlanWithStripe() {
      try {
        this.userStore.setIsLoading(!0);
        const planDetails = this.selectedPlan;
        const { data } = await ApiRequest().post(
          `/api/payments/subscribe`,
          {
            ...planDetails,
            coupon: this.coupon,
          },
          {
            headers: {
              Authorization: `Bearer ${this.accessToken}`,
            },
          }
        );
        if (data?.checkout_url) {
          this.$toast.success("Redirecting to payment");
          window.location.replace(data.checkout_url);
        } else {
          throw new Error("Something went wrong!");
        }
        this.userStore.setIsLoading(!1);
      } catch (error) {
        this.userStore.setIsLoading(!1);
        const extractedError = helper.extractAlert(error, "subscription");
        this.$toast.error(extractedError.alert.message);
        if (extractedError.redirect) {
          this.userStore.signOut();
          this.$router.push({ name: extractedError.redirect });
        }
      }
    },
    subscribeWithPayPalPlan() {
      if (this.paypalSubscribePlan == this.selectedPlan) {
        return (this.paypalSubscribePlan = null);
      }
      this.paypalSubscribePlan = this.selectedPlan;
      if (!this.renderedPayPalButtonsForPlan.includes(this.selectedPlan)) {
        this.renderedPayPalButtonsForPlan.push(this.selectedPlan);
        this.initPayPalBtn(this.selectedPlan);
      }
    },
    async initPaypalSDK() {
      if (this.paypalSDK === null) {
        this.paypalSDK = await loadScript({
          "client-id": import.meta.env.VITE_PAYPAL_CLIENT_ID,
          vault: true,
          intent: "subscription",
        });
      }
    },
    async initPayPalBtn(plan) {
      try {
        await this.initPaypalSDK();
        const subscriptionData = {
          plan_id: plan.paypal_id,
          custom_id: JSON.stringify({
            email: this.email,
            tier_id: plan.tier_id,
          }),
        };
        this.paypalSDK
          .Buttons({
            createSubscription: function (data, actions) {
              return actions.subscription.create(subscriptionData);
            },
            onApprove: (data, actions) => {
              this.$router.push({ name: "subscription-confirmed" });
            },
            onCancel: (data, actions) => {
              this.$router.push({ name: "subscription-cancelled" });
            },
            onError: (err) => {
              this.$toast.error("Something went wrong!");
            },
            style: {
              shape: "rect",
              color: "gold",
              layout: "vertical",
              label: "subscribe",
            },
          })
          .render(`#paypal-btn-${plan.price_id}`);
      } catch (error) {
        this.$toast.error("Something went wrong!");
      }
    },
  },
};
</script>

<style src="@vueform/multiselect/themes/default.scss"></style>
